"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kendo_angular_intl_1 = require("@progress/kendo-angular-intl");
var core_1 = require("@angular/core");
var kendo_angular_dateinputs_1 = require("@progress/kendo-angular-dateinputs");
var core_2 = require("@ngx-translate/core");
var moment_1 = __importDefault(require("moment"));
var CalendarDateRangeComponent = /** @class */ (function () {
    function CalendarDateRangeComponent(localeId, intlService, tService) {
        this.localeId = localeId;
        this.intlService = intlService;
        this.tService = tService;
        // define eventOUT signature
        this.dateRangeSelect = new core_1.EventEmitter();
        this.presetDateRangeSelect = new core_1.EventEmitter();
        this.show = false;
        this.lastPreselect = 'none';
        this.currentPreselect = 'none';
        this.maxEndDate = new Date();
        this.minStartDate = new Date(2009, 11, 31);
        this.defaultEndDate = this.endDate;
        this.defaultStartDate = this.startDate;
        this.range = { start: new Date(), end: new Date() };
        this.isDurationError = false;
        this.isDurationNullError = false;
        this.isFromDtGreaterThanToDt = false;
        this.enCADateFormat = 'dd/MM/yyyy';
        this.manualForcedDateFormat = '';
        if (this.intlService.localeId === 'en-CA') {
            this.manualForcedDateFormat = this.enCADateFormat;
        }
        else {
            this.manualForcedDateFormat = '';
        }
        // console.log("defaultSelectedPresetType", this.defaultSelectedPresetType);
        if (this.defaultSelectedPresetType) {
            this.lastPreselect = this.defaultSelectedPresetType;
            this.currentPreselect = this.defaultSelectedPresetType;
        }
        else {
            this.lastPreselect = 'none';
            this.currentPreselect = 'none';
        }
    }
    CalendarDateRangeComponent.prototype.dateSelected = function (date) {
        // Cast to any so I can access the private method
        this.kendoDateRangeSelectionDirective.handleChange(date);
    };
    CalendarDateRangeComponent.prototype.onToggle = function () {
        this.isDurationError = false;
        this.isDurationNullError = false;
        this.isFromDtGreaterThanToDt = false;
        this.onCancel();
    };
    CalendarDateRangeComponent.prototype.onCancel = function () {
        this.currentPreselect = this.lastPreselect;
        this.show = !this.show;
        this.range = { start: this.defaultStartDate, end: this.defaultEndDate };
    };
    CalendarDateRangeComponent.prototype.onUpdate = function () {
        this.show = !this.show;
        this.lastPreselect = 'none';
        this.currentPreselect = 'none';
        this.isDurationError = false;
        this.isDurationNullError = false;
        this.isFromDtGreaterThanToDt = false;
        this.dateRangeSelect.emit(this.range);
    };
    CalendarDateRangeComponent.prototype.onPresetSelect = function (presetType) {
        if (presetType !== 'none') {
            this.lastPreselect = presetType;
            this.currentPreselect = presetType;
            this.isDurationError = false;
            this.isDurationNullError = false;
            this.isFromDtGreaterThanToDt = false;
            this.presetDateRangeSelect.emit(presetType);
            this.show = !this.show;
        }
    };
    CalendarDateRangeComponent.prototype.checkOneYearDateRangeValidation = function (start, end) {
        if (start && end) {
            this.isDurationNullError = false;
            if (start == null) {
                this.isDurationError = true;
                return;
            }
            if (end == null) {
                this.isDurationError = true;
                return;
            }
            var endMoment = moment_1.default(end);
            var startMoment = moment_1.default(start);
            // console.log('endMoment.toObject().years',endMoment.toObject().years);
            // console.log('startMoment.toObject().years',startMoment.toObject().years);
            if (endMoment.toObject().years < 2010 || startMoment.toObject().years < 2010) {
                return;
            }
            var duartionOfYearInDays = moment_1.default(end).isLeapYear() ? 366 : 365;
            // console.log(duartionOfYearInDays);
            if (endMoment.diff(startMoment, 'days') > duartionOfYearInDays) {
                // console.log('date is greater then 1 Yr');
                this.isDurationError = true;
                return;
            }
            else {
                this.isDurationError = false;
            }
            if (endMoment.diff(startMoment, 'days') < 0) {
                // console.log('"From" date must be before the "To" date');
                this.isFromDtGreaterThanToDt = true;
            }
            else {
                this.isFromDtGreaterThanToDt = false;
            }
        }
        else {
            this.isDurationError = false;
            this.isFromDtGreaterThanToDt = false;
            this.isDurationNullError = true;
        }
    };
    CalendarDateRangeComponent.prototype.handleSelectionRange = function (selRange) {
        // if invalid date then revert to original
        if ((selRange.end > this.maxEndDate) || (selRange.start > this.maxEndDate)) {
            this.range = { start: this.defaultStartDate, end: this.defaultEndDate };
            return;
        }
        this.currentPreselect = 'none';
        this.range = { start: selRange.start, end: selRange.end };
        this.checkOneYearDateRangeValidation(selRange.start, selRange.end);
    };
    CalendarDateRangeComponent.prototype.onStartChange = function (value) {
        this.currentPreselect = 'none';
        this.range.start = value;
        this.checkOneYearDateRangeValidation(this.range.start, this.range.end);
    };
    CalendarDateRangeComponent.prototype.onEndChange = function (value) {
        this.currentPreselect = 'none';
        this.range.end = value;
        this.checkOneYearDateRangeValidation(this.range.start, this.range.end);
    };
    CalendarDateRangeComponent.prototype.isFutureDate = function (date) {
        return date > this.maxEndDate ? 'futureDates' : '';
    };
    CalendarDateRangeComponent.prototype.isValidDate = function (date) {
        return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
    };
    CalendarDateRangeComponent.prototype.ngOnChanges = function () {
        if (!this.isValidDate(this.endDate)) {
            this.endDate = new Date(this.endDate + '');
        }
        if (!this.isValidDate(this.startDate)) {
            this.startDate = new Date(this.startDate + '');
        }
        this.defaultEndDate = this.endDate;
        this.defaultStartDate = this.startDate;
        this.range = { start: this.defaultStartDate, end: this.defaultEndDate };
        if (this.defaultSelectedPresetType) {
            this.lastPreselect = this.defaultSelectedPresetType;
            this.currentPreselect = this.defaultSelectedPresetType;
        }
        else {
            this.lastPreselect = 'none';
            this.currentPreselect = 'none';
        }
    };
    return CalendarDateRangeComponent;
}());
exports.CalendarDateRangeComponent = CalendarDateRangeComponent;
